<template>
  <div class="logo">
    <img class="logo" src="../../assets/img/zawaroom.svg" />
  </div>
</template>

<script>
export default {
  name: 'Logo',
};
</script>

<style scoped>
.logo {
  width: 174px;
  height: auto;
}
</style>
